import Swal from 'sweetalert2';
import { deleteCertificate } from "../../../api/certificateAPI";

export const handleDeleteCertificate = async (
  id,
  certificates,
  setCertificates
) => {
  const confirmation = await Swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  });

  if (!confirmation.isConfirmed) {
    return;
  }

  try {
    Swal.fire({
      title: 'Deleting...',
      text: 'Please wait while we delete the certificate.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    await deleteCertificate(id);

    setCertificates(certificates.filter((certificate) => certificate.id !== id));

    Swal.fire({
      icon: 'success',
      title: 'Deleted!',
      text: 'Certificate has been deleted.',
    });
  } catch (error) {
    console.error("Error deleting certificate:", error);
    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: 'Failed to delete certificate.',
    });
  }
};
